import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Menu, Search, LogOut } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export function Header({ onMenuClick, onLogout }) {
  return (
    <header className="h-16 border-b border-border bg-card/50 backdrop-blur-xl px-4 flex items-center justify-between gap-4">
      <div className="flex items-center gap-4">
        <Button
          variant="ghost"
          size="icon"
          className="lg:hidden"
          onClick={onMenuClick}
        >
          <Menu className="w-5 h-5" />
        </Button>
        <div className="relative hidden sm:block">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
          <Input
            placeholder="Search teams, matches..."
            className="w-64 pl-9 bg-secondary/50 border-border/50 focus:bg-secondary"
          />
        </div>
      </div>

      <div className="flex items-center gap-2">
        {onLogout && (
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={onLogout}
                  data-testid="header-logout-button"
                >
                  <LogOut className="w-5 h-5" />
                </Button>
              </TooltipTrigger>
              <TooltipContent>
                <p>Sign out</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        )}

        <div className="w-9 h-9 rounded-full bg-gradient-to-br from-primary to-accent flex items-center justify-center text-sm font-semibold text-primary-foreground ml-2">
          ST
        </div>
      </div>
    </header>
  );
}
